export default __webpack_public_path__ + "/src/assets/images/ic-modal-title-change-number-of-users.svg";